import * as React from "react";
import { nodes } from "../api-data";
import { CategoryTitle } from "./category-title";
import { VerticalGroup } from "../vertical-group";
import { height, useZoomContext } from "../zoom-container";
import { ZoomForeignObject } from "./zoom-foreign-object";
import { elementWidth } from "../dimensions";

export function Nodes({ scaleItems }) {
  const { zoomTo } = useZoomContext();

  const horizontalPadding = -1;

  const rectWidth = elementWidth + horizontalPadding * 2;
  const rectHeight = 229;

  const rectX = 2050;
  const rectY = height * (1 / 2) - rectHeight / 2;

  const zoomToInNodesGroup = (e, { x, y, k }) =>
    zoomTo(e, {
      x: rectX + x,
      y: rectY + y,
      k,
    });

  return (
    <g id="nodes" transform={`translate(${rectX},${rectY})`}>
      <CategoryTitle>React Elements</CategoryTitle>
      <rect
        onClick={(e) => {
          // console.log("zoom dan");
          zoomToInNodesGroup(e, {
            x: rectWidth / 2,
            y: rectHeight / 2,
            k: 2,
          });
        }}
        cursor="pointer"
        x={0}
        y={0}
        rx={16}
        id="nodes"
        role="button"
        width={rectWidth}
        height={rectHeight}
        strokeWidth={1}
        stroke="dimgray"
        fill="hsl(0deg 0% 97%)"
        filter="url(#shadow)"
      />
      <ZoomForeignObject
        height={nodes.size * 100 + 20}
        width={elementWidth}
        x={horizontalPadding}
        y={12}
        onZoom={zoomToInNodesGroup}
      >
        <VerticalGroup data={nodes} name="Nodes" scaleItems={scaleItems} />
      </ZoomForeignObject>
    </g>
  );
}
